import _ from 'lodash';
import Columns from '../../grid/columns';

export default instance => {
  instance.attachEvent('onGridResize', (oldWidth, newWidth) => {
    instance.config.grid_width = newWidth;

    return true;
  });

  instance.attachEvent('onGridResizeEnd', (oldWidth, newWidth) => {
    _.delay(() => {
      // instance.callEvent('onBeforeGanttRender');
      Columns.onGridResizeEnd(oldWidth, newWidth);
      // instance.callEvent('onAfterGanttRender');
    });
  
    return true;
  });
};
